// NÉVE Smart Search v7

(function () {
  'use strict';

  // Season terms — when query is season-only, exclude non-matching products
  const SEASON_TERMS = ['summer','winter','monsoon','spring','autumn','fall','allweather'];

  // ─── Aliases ──────────────────────────────────────────────────────────────
  const ALIASES = {
    'br540':'baccarat rouge 540','br 540':'baccarat rouge 540',
    'baccarat':'baccarat rouge 540','baccarat rouge':'baccarat rouge 540',
    'mfk':'maison francis kurkdjian','mkf':'maison francis kurkdjian',
    'git':'green irish tweed','green irish':'green irish tweed',
    '9pm':'9pm rebel','cr7':'cr7 blue',
    'dg':'dolce gabbana','d&g':'dolce gabbana',
    'paco':'paco rabanne','lv':'louis vuitton',
    'vs':'victoria secret','bvlgari':'bvlgari','bulgari':'bvlgari',
    'khamrah':'khamrah qahwa','erba':'erba pura',
    'sexy':'amber musk rose','romantic':'floral rose jasmine',
    'clubbing':'oud tobacco night','gym':'fresh aquatic citrus',
    'cozy':'vanilla warm gourmand',
    'bold':'oud dark intense','subtle':'soft musk light',
    'sensual':'amber musk vanilla','mysterious':'oud smoky dark',
    'elegant':'floral rose musk','boozy':'rum tobacco',
    'tropical':'mango pineapple fruity','zesty':'lemon citrus bergamot',
    'spiced':'cinnamon cardamom nutmeg','creamy':'vanilla milk panna cotta',
    'long lasting':'enormous strong','longlasting':'enormous strong',
    'aura':'soft musk amber floral',
    'vibe':'mood fresh dark warm',
    'chill':'soft musk vanilla cozy',
    'power':'bold oud dark intense',
    'clean girl':'fresh aquatic musk light',
    'clean boy':'fresh aquatic citrus aromatic',
    'old money':'oud amber sandalwood leather',
    'quiet luxury':'soft musk sandalwood iris powdery',
    'boyfriend':'fresh aromatic woody musk',
    'girlfriend':'floral musk rose vanilla',
    'boss':'oud dark leather intense',
    'summer crush':'citrus aquatic fresh floral',
    'date night':'amber vanilla musk rose oud jasmine',
    'sunday morning':'soft musk vanilla clean light',
    'rainy day':'woody earthy moss vetiver',
    'night out':'oud tobacco amber dark musk',
    'office':'fresh aquatic clean citrus aromatic lavender',
    'wedding':'floral rose jasmine white flowers musk',
    'beach':'aquatic citrus summer',
    'library':'woody earthy leather moss',
    'forest':'green moss woody vetiver cedar',
    'coffee shop':'vanilla coffee gourmand warm',
    'airport':'fresh clean citrus musk',
    'petrichor':'earthy moss vetiver green woody',
    'ozonic':'aquatic sea notes fresh marine',
    'crowd stopper':'enormous strong oud amber',
    'projection beast':'enormous strong oud amber',
    'blind buy':'safe fresh aquatic musk',
    'blue thunder':'blue thunder',
    'barbershop':'powdery citrus aromatic fougere',
    'retro':'powdery aromatic barbershop classic',
    'powdery fresh':'powdery aromatic ozonic musk',
    'megamare':'megamare orto parisi',
    'orto':'orto parisi','orto parisi':'orto parisi',
    'ultra male':'ultra male jean paul gaultier','jpg':'jean paul gaultier',
    'imagination':'imagination louis vuitton',
    'bleu':'bleu de chanel','bleu de chanel':'bleu de chanel','bdc':'bleu de chanel',
    'hugo iced':'hugo iced hugo boss','hugo boss':'hugo boss',
    'tuberose astrale':            'tuberose astrale parfums de marly',
    'astrale':                     'tuberose astrale parfums de marly',
    'althair':                     'althair parfums de marly',
    'altair':                      'althair parfums de marly',
    'stronger with you intensely': 'stronger with you intensely emporio armani',
    'stronger with you':           'stronger with you intensely emporio armani',
    'swyi':                        'stronger with you intensely emporio armani',
    'swy':                         'stronger with you emporio armani',
    'emporio armani':              'emporio armani',
    'armani':                      'emporio armani',
    'burberry hero':               'burberry hero',
    'hero edt':                    'burberry hero',
    'burberry':                    'burberry',

    // All-weather
    'all weather':   'allweather',
    'all-weather':   'allweather',
    'all season':    'allweather',
    'all seasons':   'allweather',
    'year round':    'allweather',

    'sauvage':       'sauvage dior',          
    'sauvage edp':   'sauvage edp dior',
    'layton':        'layton parfums de marly',
    'pdm':           'parfums de marly',
    'parfums de marly': 'parfums de marly',
    'kayali':        'kayali',
    'afgano':        'black afgano nasomatto',
    'black afgano':  'black afgano nasomatto',
    'nasomatto':     'nasomatto',
    'shaghaf':       'shaghaf oud swiss arabian',
    'shaghaf oud':   'shaghaf oud swiss arabian',
    'swiss arabian': 'swiss arabian',
    'ysl y':         'y edp yves saint laurent',
    'y edp':         'y edp yves saint laurent',
    'ysl':           'yves saint laurent',
  };

  // ─── Synonyms ─────────────────────────────────────────────────────────────
  const SYNONYMS = {
    citrus:    ['lemon','bergamot','orange','grapefruit','mandarin','citron','tangerine','sicilian lemon','calabrian bergamot','sicilian orange','candied lemon','lemon verbena'],
    lemon:     ['citron','candied lemon','sicilian lemon','lemon verbena'],
    bergamot:  ['calabrian bergamot'],
    aquatic:   ['sea notes','marine','aquatic accords','ocean'],
    fresh:     ['sea notes','citron','mint','green notes','clean','aquatic accords'],
    mint:      ['peppermint'],
    green:     ['green notes','violet leaf','basil','moss','oakmoss'],
    floral:    ['rose','jasmine','iris','violet','peony','tuberose','orange blossom','ylang','lilac','lily of the valley','hedione','white flowers', 'osmanthus', 'cypress'],
    fruity:    ['apple','pear','pineapple','blackcurrant','mango','apricot','fig','strawberry','red berries','mixed fruits','candied fruits', 'melon'],
    woody:     ['sandalwood','cedar','cedarwood','patchouli','vetiver','haitian vetiver','oud','agarwood','guaiac wood','amberwood','dry woods','woods','oakmoss', 'cypress'],
    oud:       ['agarwood'],
    spicy:     ['pepper','cardamom','cinnamon','nutmeg','clove','ginger','saffron','spices','rum'],
    warm:      ['amber','ambergris','amberwood','musk','vanilla','benzoin','resin','fir resin','ambroxan','tonka bean'],
    amber:     ['amberwood','ambroxan','labdanum'],
    musk:      ['white musk','cashmeran'],
    vanilla:   ['madagascar vanilla','tonka bean', 'vanille'],
    gourmand:  ['vanilla','caramel','praline','coffee','sugar','tonka bean','panna cotta','milk','hazelnut','butter','candied fruits', 'toffee','chestnut','almond','bitter almond'],
    sweet:     ['vanilla','caramel','sugar','tonka bean','panna cotta','milk','toffee','almond'],
    smoky:     ['tobacco','leather','oud','incense','licorice'],
    dark:      ['tobacco','leather','oud','incense','patchouli'],
    incense:   ['myrrh','olibanum','fir resin', 'elemi'],
    musky:     ['musk','ambergris','white musk','cashmeran','ambroxan'],
    powdery:   ['iris','violet','musk','benzoin'],
    fougere:   ['fougere','aromatic','lavender','moss'],
    oriental:  ['oud','amber','incense','myrrh','sandalwood','vanilla','saffron','spices'],
    office:    ['fresh','aquatic','clean','citrus','aromatic','lavender'],
    date:      ['amber','vanilla','musk','rose','oud','jasmine'],
    night:     ['oud','amber','tobacco','leather','musk','dark'],
    masculine: ['men','him','male'],
    feminine:  ['women','her','female'],
    unisex:    ['gender neutral'],
    men:       ['masculine','male'],
    women:     ['feminine','female'],
    strong:    ['enormous','long lasting'],
    soft:      ['intimate','light'],
    earthy:    ['vetiver','patchouli','oakmoss','moss','green notes','woods'],
    leather:   ['tobacco','birch','styrax', 'suede'],
    clean:     ['sea notes','citron','mint','green notes','aquatic accords','white musk','ambroxan'],
    intimate:  ['musk','ambroxan','white musk','cashmeran'],
    enormous:  ['strong','long lasting','sillage','projection'],
    safe:      ['fresh','aquatic','clean','citrus','light'],
    marine:    ['sea notes','seaweed','calone','ozonic','aquatic accords','ozone'],
    tea:       ['black tea','wild tea','chinese black tea'],
    cold:      ['frozen mint','mint','peppermint','icy','arctic'],
    ginger:    ['nigerian ginger'],
    neroli:    ['tunisian neroli','orange blossom'],
    cinnamon:  ['ceylon cinnamon'],
    pepper:    ['pink pepper','black pepper'],
    juniper:   ['juniper berry','gin'],
    sage:      ['clary sage'],
    aromatic:  ['lavender','mint','sage','clary sage','basil','rosemary'],
    cedar:     ['cedarwood','virginia cedar','atlas cedar','himalayan cedarwood'],
    tuberose:  ['white flowers','gardenia','orange blossom'],
    lavender:  ['lavandin','fougere','aromatic'],
    cypress:   ['juniper','juniper berry','pine','fir'],
    suede:     ['leather','nubuck'],
    almond:    ['bitter almond','marzipan','heliotrope'],
    osmanthus: ['apricot','leather','tea'],
    toffee:    ['caramel','butterscotch','praline'],
    praline:   ['caramel','toffee','sugar','nougat'],
    ambroxan:  ['amber','ambergris','amberwood'],
    cardamom:  ['green cardamom','black cardamom'],
    elemi:     ['resin','incense','olibanum','frankincense'],
  };

  function resolveQuery(query) {
    let q = query.toLowerCase().trim();
    const keys = Object.keys(ALIASES).sort((a,b) => b.length - a.length);
    for (const k of keys) { if (q.includes(k)) q = q.replace(k, ALIASES[k]); }
    return q;
  }

  function expandToken(token) {
    const t = token.toLowerCase().trim();
    const out = new Set([t]);
    if (SYNONYMS[t]) {
      SYNONYMS[t].forEach(s => out.add(s));
    } else {
      // Only fall back to "which broader category lists this term" when the
      // term has no dedicated entry of its own. Without this guard, a specific
      // material like "oud" — which appears as one example note inside both
      // the woody and oriental arrays, but ALSO has its own entry — ends up
      // expanding into "woody" and "oriental" as literal search terms, so
      // family-level matches (any product tagged Woody/Oriental) drown out
      // actual oud-note products. Terms without their own entry (e.g. plain
      // "sandalwood") still get this broader-category fallback as intended.
      for (const [k, vals] of Object.entries(SYNONYMS)) {
        if (vals.some(v => v === t)) out.add(k);
      }
    }
    return Array.from(out);
  }

  function extractSeasonTokens(tokens) {
    return tokens.filter(t => SEASON_TERMS.includes(t));
  }

  function noteMatches(note, term) {
    if (!note || !term) return false;
    if (note === term) return true;
    if (term.length >= 2) {
      if (note.startsWith(term)) return true;
      const words = note.split(/[\s-]+/);
      if (words.some(w => w.startsWith(term))) return true;
    }
    if (note.length >= 3 && term.includes(note)) return true;
    return false;
  }

  function scoreProduct(p, tokens, seasonTokens) {
    if (seasonTokens.length > 0) {
      const hasAllWeather = p.seasons.some(s => s === 'all-weather' || s === 'all weather');
      const isAllWeatherQuery = seasonTokens.every(st => st === 'allweather');

      if (isAllWeatherQuery) {
        // "all weather" search — only return products that are all-weather
        if (!hasAllWeather) return { score: 0, matchReasons: [] };
      } else {
        // Specific season search — all-weather products always pass, others must match
        const nonAW = seasonTokens.filter(st => st !== 'allweather');
        const matchesSeason = p.seasons.some(s =>
          nonAW.some(st => s.toLowerCase().includes(st) || st.includes(s.toLowerCase()))
        );
        if (!hasAllWeather && !matchesSeason) return { score: 0, matchReasons: [] };
      }
    }

    let score = 0;
    const reasons = [];
    const title = p.title.toLowerCase();

    for (const raw of tokens) {
      const isSeason = SEASON_TERMS.includes(raw);

      // Score season tokens directly and skip note matching
      if (isSeason) {
        if (raw === 'allweather') {
          // Explicit all-weather query — score products that have all-weather
          if (p.seasons.some(s => s === 'all-weather' || s === 'all weather')) {
            score += 8;
            addR(reasons, 'Season: All-weather');
          }
        } else {
          const matched = p.seasons.find(s => s.toLowerCase().includes(raw));
          if (matched) {
            score += 8;
            addR(reasons, `Season: ${cap(matched)}`);
          } else if (p.seasons.some(s => s === 'all-weather' || s === 'all weather')) {
            score += 4;
            addR(reasons, `Season: All-weather`);
          }
        }
        continue;
      }

      for (const term of expandToken(raw)) {
        if (title.includes(term)) score += 10;

        for (const insp of p.inspired_by) {
          const fn = insp.fragrance.toLowerCase();
          const fb = insp.brand.toLowerCase();
          if (fn.includes(term) || (term.length > 3 && fn.startsWith(term))) {
            score += 9;
            addR(reasons, `Inspired by: ${insp.fragrance} – ${insp.brand}`);
          } else if (fb.includes(term)) {
            score += 6;
            addR(reasons, `Inspired by: ${insp.fragrance} – ${insp.brand}`);
          }
        }

        p.top.filter(n  => noteMatches(n, term)).forEach(n => { score += 5; addR(reasons, `Note: ${cap(n)}`); });
        p.mid.filter(n  => noteMatches(n, term)).forEach(n => { score += 4; addR(reasons, `Note: ${cap(n)}`); });
        p.base.filter(n => noteMatches(n, term)).forEach(n => { score += 3; addR(reasons, `Note: ${cap(n)}`); });
        p.families.filter(f => noteMatches(f, term)).forEach(f => { score += 4; addR(reasons, `Family: ${cap(f)}`); });

        if ((term==='men'||term==='masculine'||term==='him'||term==='male') && (p.gender==='men'||p.gender==='unisex')) score += 3;
        if ((term==='women'||term==='feminine'||term==='her'||term==='female') && (p.gender==='women'||p.gender==='unisex')) score += 3;
        if (term==='unisex' && p.gender==='unisex') score += 3;
      }
    }

    return { score, matchReasons: reasons.slice(0, 3) };
  }

  function addR(arr, r) { if (!arr.includes(r)) arr.push(r); }

  function runSearch(query, products, limit) {
    limit = limit || 8;
    const resolved = resolveQuery(query);
    if (!resolved || resolved.trim().length < 2) return [];
    const tokens = resolved.trim().split(/\s+/).filter(t => t.length > 1);
    if (!tokens.length) return [];
    const seasonTokens = extractSeasonTokens(tokens);
    const results = [];
    for (const p of products) {
      const { score, matchReasons } = scoreProduct(p, tokens, seasonTokens);
      // Require score > 5 for single-token queries to avoid overly broad matches
      const minScore = 3;
      if (score >= minScore) results.push({ product: p, score, matchReasons });
    }
    results.sort((a, b) => b.score - a.score);
    return results.slice(0, limit);
  }

  // ─── HTML builders ────────────────────────────────────────────────────────
  function dropdownHTML(results, query) {
    if (!query || query.trim().length < 2) return '';

    if (results.length === 0) {
      return `<div id="predictive-search-results" role="listbox">
        <div class="neve-ps-empty">
          <p class="neve-ps-empty__msg">No matches for <em>"${esc(query)}"</em></p>
          <p class="neve-ps-empty__hint">Try: a note · a mood · an inspiration</p>
        </div>
      </div>`;
    }

    const items = results.map((r, i) => {
      const p = r.product;
      const priceEl = p.available ? `<span class="neve-ps-price">₹${p.price}</span>` : `<span class="neve-ps-sold">Sold out</span>`;
      const tagsEl  = r.matchReasons.length ? `<div class="neve-ps-tags">${r.matchReasons.map(t => `<span>${esc(t)}</span>`).join('')}</div>` : '';
      return `<li id="predictive-search-option-${i}" class="predictive-search__list-item neve-ps-item" role="option" aria-selected="false">
        <a href="${p.url}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text neve-ps-link" tabindex="-1">
          <img class="predictive-search__image neve-ps-img" src="${p.image}" alt="${esc(p.title)}" width="52" height="52" loading="lazy">
          <div class="predictive-search__item-content neve-ps-body">
            <p class="predictive-search__item-heading neve-ps-title">${esc(p.title)}</p>
            ${priceEl}${tagsEl}
          </div>
        </a>
      </li>`;
    }).join('');

    return `<div id="predictive-search-results" role="listbox">
      <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper neve-ps-wrapper">
        <div class="predictive-search__result-group">
          <ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled neve-ps-list" role="group">
            ${items}
          </ul>
        </div>
      </div>
    </div>`;
  }

  // ─── Styles ───────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('neve-search-styles')) return;
    const s = document.createElement('style');
    s.id = 'neve-search-styles';
    s.textContent = `
      /* ── Search modal background ── */
      .search-modal { background: #F8F6F3 !important; border-bottom: 1px solid #E4DCCF !important; }
      /* ── Search input: minimal underline style ── */
      .search-modal .field,
      .search-modal__form .field { border-radius:0!important; background:transparent!important; box-shadow:none!important; }
      .search-modal .field::before,
      .search-modal .field::after,
      .search-modal__form .field::before,
      .search-modal__form .field::after { display:none!important; }
      .search-modal .field__input,
      .search-modal__form .search__input {
        background: transparent !important;
        border: none !important;
        border-bottom: 1px solid rgba(40,30,18,0.2) !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        font-family: 'Cormorant Garamond', serif !important;
        font-size: 22px !important;
        font-weight: 400 !important;
        letter-spacing: 0.04em !important;
        color: rgba(40,30,18,0.85) !important;
        padding: 10px 4.4rem 10px 0 !important;
        height: auto !important;
        margin: 0 !important;
        caret-color: #D4AF37 !important;
      }
      .search-modal .field__input:focus,
      .search-modal__form .search__input:focus {
        border-bottom-color: #D4AF37 !important;
        outline: none !important;
        box-shadow: none !important;
        padding: 10px 4.4rem 10px 0 !important;
      }
      /* Placeholder */
      .search-modal .field__input::placeholder,
      .search-modal__form .search__input::placeholder {
        font-family: 'Amiri', serif !important;
        font-size: 13px !important;
        letter-spacing: 0.06em !important;
        color: rgba(40,30,18,0.32) !important;
        font-weight: 400 !important;
        opacity: 1 !important;
      }
      @media(max-width:749px){
        .search-modal .field__input::placeholder,
        .search-modal__form .search__input::placeholder { font-size: 12px !important; }
        /* Prevent iOS font-size zoom — must be 16px+ */
        .search-modal .field__input,
        .search-modal__form .search__input { font-size: 16px !important; }
      }

      @media (max-width: 749px){

        /* Keep container centered but balanced */
        .search-modal__content {
        padding-left: 18px !important;
        padding-right: 18px !important;
        }

        /* Input spacing: equal left/right feel */
        .search-modal .field__input,
        .search-modal__form .search__input {
        padding-left: 0 !important;
        padding-right: 56px !important; /* space for icon */
        }

        /* Fix icon vertical alignment */
        .search-modal .field__button {
        top: 50% !important;
        transform: translateY(-50%) !important;
        }

        /* Make underline feel longer (optical balance) */
        .search-modal .field {
        width: 100% !important;
        }

      }
        
      /* Hide floating label */
      .search-modal .field__label { display:none!important; }
      /* ── Hide the close button entirely ── */
      .search-modal__close-button { display: none !important; }
      /* ── Results panel ── */
      .predictive-search {
        background: #F8F6F3 !important;
        border: none !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        border-top: 1px solid #E4DCCF !important;
        max-height: 60vh !important;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch !important;
      }
      .neve-ps-wrapper{padding:0!important;}
      .neve-ps-list{padding:0!important;margin:0!important;}
      .neve-ps-item{border-bottom:0.5px solid #E4DCCF!important;list-style:none!important;}
      .neve-ps-item:last-child{border-bottom:none!important;}
      .neve-ps-link{display:flex!important;align-items:center!important;gap:14px!important;padding:13px 20px!important;text-decoration:none!important;transition:background 0.15s!important;box-shadow:none!important;}
      .neve-ps-link:hover{background:rgba(228,220,207,0.35)!important;}
      .neve-ps-img{width:52px!important;height:52px!important;object-fit:cover!important;flex-shrink:0!important;background:#ede8de!important;box-shadow:none!important;}
      .neve-ps-body{flex:1!important;min-width:0!important;display:flex!important;flex-direction:column!important;gap:3px!important;}
      .neve-ps-title{font-family:'Cormorant Garamond',serif!important;font-size:16px!important;font-weight:400!important;letter-spacing:0.05em!important;color:rgba(40,30,18,0.85)!important;margin:0!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;text-shadow:none!important;}
      .neve-ps-price{font-family:'Amiri',serif!important;font-size:12px!important;letter-spacing:0.06em!important;color:rgba(40,30,18,0.45)!important;text-shadow:none!important;}
      .neve-ps-sold{font-family:'Amiri',serif!important;font-size:10px!important;letter-spacing:0.14em!important;text-transform:uppercase!important;color:rgba(40,30,18,0.28)!important;text-shadow:none!important;}
      .neve-ps-tags{display:flex!important;flex-wrap:wrap!important;gap:4px!important;margin-top:2px!important;}
      .neve-ps-tags span{font-family:'Amiri',serif!important;font-size:10px!important;letter-spacing:0.1em!important;text-transform:uppercase!important;color:#b8922a!important;background:rgba(212,175,55,0.1)!important;padding:1px 7px!important;border-radius:2px!important;white-space:nowrap!important;text-shadow:none!important;box-shadow:none!important;}
      .neve-ps-empty{padding:28px 20px;text-align:center;}
      .neve-ps-empty__msg{font-family:'Cormorant Garamond',serif;font-size:17px;font-weight:400;color:rgba(40,30,18,0.55);margin:0 0 6px;text-shadow:none;}
      .neve-ps-empty__hint{font-family:'Amiri',serif;font-size:11px;letter-spacing:0.12em;color:rgba(40,30,18,0.32);margin:0;text-transform:uppercase;}
      @media(max-width:749px){
        .neve-ps-link{padding:11px 16px!important;gap:12px!important;}
        .neve-ps-img{width:44px!important;height:44px!important;}
        .neve-ps-title{font-size:15px!important;}
      }
      /* Hint line — desktop only, below the form */
      .search-modal__content{flex-wrap:wrap!important;}
      .neve-search-hint{font-family:'Amiri',serif!important;font-size:13px!important;letter-spacing:0.07em!important;color:rgba(40,30,18,0.38)!important;margin:0!important;padding:8px 0 2px 0!important;line-height:1.5!important;display:block!important;width:100%!important;box-sizing:border-box!important;}
      .neve-search-hint em{font-style:normal!important;color:rgba(40,30,18,0.55)!important;}
      @media(max-width:749px){ .neve-search-hint{display:none!important;} }
      /* ── Results page ── */
    .neve-results-header{font-family:'Amiri',serif;font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:rgba(40,30,18,0.38);margin:0 0 32px;display:block;}
    .neve-results-header em{font-style:normal;color:rgba(40,30,18,0.65);}

    /* Match reason captions */
    .neve-match-reasons{
    display:flex !important; flex-wrap:wrap !important; gap:6px !important;
    margin: 10px 0 0 !important; padding: 0 !important;
    position: static !important; justify-content: center !important;
    width: 100% !important; max-width: 100% !important;
    min-width: 0 !important; box-sizing: border-box !important;
    list-style: none !important;
    }
    .neve-match-reasons span{
    font-family:'Amiri',serif !important; font-size:9.5px !important;
    letter-spacing:0.14em !important; text-transform:uppercase !important;
    color:#b8922a !important; background:transparent !important;
    padding:0 !important; border-radius:0 !important;
    white-space:normal !important; overflow-wrap:anywhere !important;
    max-width:100% !important; min-width:0 !important;
    font-weight:500 !important; display:inline-block !important; line-height:1.3 !important;
    }
    .neve-match-reasons span:not(:last-child)::after{
    content: '·' !important; margin: 0 0 0 8px !important;
    color: rgba(184,146,42,0.5) !important;
    }
    @media(max-width:749px){
    .neve-match-reasons{gap:4px !important;margin-top:8px !important;}
    .neve-match-reasons span{font-size:8.5px !important;letter-spacing:0.12em !important;}
    .neve-match-reasons span:not(:last-child)::after{margin: 0 0 0 6px !important;}
    }

    .neve-results-empty{
    grid-column:1/-1; text-align:center; padding:60px 20px; list-style:none;
    width:100%; display:flex; flex-direction:column; align-items:center; justify-content:center;
    }
    .template-search .product-grid{
    justify-items:center;
    }
    .neve-results-empty__msg{font-family:'Cormorant Garamond',serif;font-size:24px;font-weight:300;color:rgba(40,30,18,0.55);margin:0 0 10px;}
    .neve-results-empty__hint{font-family:'Amiri',serif;font-size:13px;letter-spacing:0.1em;color:rgba(40,30,18,0.35);margin:0;}

    .neve-has-results [role="status"]{display:none!important;}

    /* ── Hide filters and sort on search page ── */
    .template-search .facets-wrapper,
    .template-search facet-filters-form,
    .template-search .facets-vertical-sort,
    .template-search #main-search-filters,
    .template-search .facets,
    .template-search .facets-horizontal { display: none !important; }
    `;
    document.head.appendChild(s);
  }

  function cap(s) { return s ? s[0].toUpperCase() + s.slice(1) : ''; }
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function debounce(fn, ms) { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; }

  function injectHint(input) {
    input.placeholder = 'note · mood · inspiration';

    const psEl = input.closest('predictive-search') || input.closest('.search-modal__form');
    const target = psEl || input.closest('form');
    if (!target || target.querySelector('.neve-search-hint')) return;
    const hint = document.createElement('p');
    hint.className = 'neve-search-hint';
    hint.innerHTML = 'e.g. note - <em>bergamot, jasmine, musk</em> &nbsp;&middot;&nbsp; mood - <em>fresh, dark</em> &nbsp;&middot;&nbsp; inspiration - <em>Sauvage, Xerjoff, BR540</em>';
    target.appendChild(hint);
  }

  // ─── iOS zoom fix ─────────────────────────────────────────────────────────
  // iOS Safari zooms the viewport when an input receives focus if font-size < 16px.
  // We temporarily disable user scaling while the search modal is active.
  function fixIOSZoom() {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;
    const original = viewport.getAttribute('content');
    document.addEventListener('focusin', e => {
      if (e.target && e.target.closest('.search-modal')) {
        viewport.setAttribute('content', original + ', maximum-scale=1, user-scalable=0');
      }
    });
    document.addEventListener('focusout', e => {
      if (e.target && e.target.closest('.search-modal')) {
        setTimeout(() => viewport.setAttribute('content', original), 300);
      }
    });
  }

  // ─── Strategy A: patch customElements.define ──────────────────────────────
  function patchCustomElements(products) {
    if (typeof customElements === 'undefined') return;
    const orig = customElements.define.bind(customElements);
    customElements.define = function (name, cls, opts) {
      if (name === 'predictive-search') {
        class NevePS extends cls {
          constructor() {
            super();
            this._P = products;
          }

          onChange() {
            const rb = this.querySelector('button[type="reset"]');
            if (rb) { this.input.value.length > 0 ? rb.classList.remove('hidden') : rb.classList.add('hidden'); }
            const q = this.input ? this.input.value.trim() : '';
            if (!q) { this.close(true); return; }
            if (q.length < 2) return;
            this._go(q);
          }

          _go(q) {
            const results = runSearch(q, this._P, 8);
            const html = dropdownHTML(results, q);
            if (html) {
              this.renderSearchResults(html);
            } else {
              this.close(true);
            }
            window.__NEVE_LAST__ = { q, results };
          }

          getSearchResults(term) { this._go(term); }

          onFormSubmit(e) {
            e.preventDefault();
            const sel = this.querySelector('[aria-selected="true"] a');
            if (sel) { sel.click(); return; }
            const q = this.input ? this.input.value.trim() : '';
            if (!q) return;
            submitSearch(q, this._P);
          }

          onFocus() {
            if (this.input && this.input.value.trim()) super.onFocus();
          }
        }
        return orig(name, NevePS, opts);
      }
      return orig(name, cls, opts);
    };
  }

  // ─── Strategy B: direct input listener fallback ───────────────────────────
  function directFallback(products) {
    function bind(input) {
      if (input.__neve__) return;
      input.__neve__ = true;

      injectHint(input);

      const getPanel = () => {
        const ps = input.closest('predictive-search');
        return ps ? ps.querySelector('[data-predictive-search]') : null;
      };

      const openPanel = (html) => {
        const panel = getPanel();
        const psEl  = input.closest('predictive-search');
        if (!panel || !html) return;
        panel.innerHTML = html;
        if (psEl) {
          psEl.setAttribute('results','true');
          psEl.setAttribute('open','true');
          input.setAttribute('aria-expanded','true');
          if (typeof psEl.getResultsMaxHeight === 'function') {
            const h = psEl.getResultsMaxHeight();
            if (h > 0) panel.style.maxHeight = h + 'px';
          }
        }
      };

      const doSearch = debounce((q) => {
        const results = runSearch(q, products, 8);
        const html = dropdownHTML(results, q);
        openPanel(html);
        window.__NEVE_LAST__ = { q, results };
      }, 150);

      const onType = e => {
        const q = e.target.value.trim();
        if (!q) {
          const ps = input.closest('predictive-search');
          if (ps && typeof ps.close === 'function') ps.close(false);
          return;
        }
        if (q.length < 2) return;
        doSearch(q);
      };
      input.addEventListener('input', onType);
      input.addEventListener('keyup', onType);

      const form = input.closest('form');
      if (form && !form.__neve__) {
        form.__neve__ = true;
        form.addEventListener('submit', e => {
          const sel = document.querySelector('[aria-selected="true"] a');
          if (sel) { e.preventDefault(); sel.click(); return; }
          const q = input.value.trim();
          if (!q) return;
          e.preventDefault();
          submitSearch(q, products);
        });
      }
    }

    function bindAll() {
      document.querySelectorAll('input[type="search"]').forEach(inp => {
        if (inp.closest('predictive-search') || inp.closest('main-search')) bind(inp);
      });
    }

    bindAll();

    const obs = new MutationObserver(bindAll);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function submitSearch(q, products) {
    const url = new URL(window.location.origin + '/search');
    url.searchParams.set('q', q);
    url.searchParams.set('type', 'product');
    window.location.href = url.toString();
  }


  // ─── Search results page ──────────────────────────────────────────────────
  async function handleResultsPage() {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q') || '';
    if (!query) return;

    const results = runSearch(query, window.__NEVE_PRODUCTS__, 50);
    const handles = results.map(r => r.product.handle);
    const reasons = {};
    results.forEach(r => { reasons[r.product.handle] = r.matchReasons; });

    // Wait for grid ul to render
    let attempts = 0;
    let gridContainer = document.getElementById('product-grid');
    let grid = gridContainer ? gridContainer.querySelector('ul.grid') : null;
    while (!grid && attempts < 30) {
        await new Promise(r => setTimeout(r, 100));
        gridContainer = document.getElementById('product-grid');
        grid = gridContainer ? gridContainer.querySelector('ul.grid') : null;
        attempts++;
    }
    if (!grid) return;

    // Hide immediately to prevent flash of Shopify's own results
    grid.style.visibility = 'hidden';
    grid.style.minHeight = grid.offsetHeight + 'px';

    // Mark page state
    const section = document.querySelector('.template-search, main') || document.body;
    section.classList.add('neve-has-results');
    document.querySelectorAll('[role="status"]').forEach(el => el.style.display = 'none');

    // Update results header
    updateResultsHeader(query, results.length);

    // Empty state
    if (results.length === 0) {
        grid.innerHTML = `
        <li class="neve-results-empty">
            <p class="neve-results-empty__msg">No matches for "${esc(query)}"</p>
            <p class="neve-results-empty__hint">Try a note like "bergamot", a mood like "fresh summer", or an inspiration like "Sauvage"</p>
        </li>`;
        grid.style.visibility = '';
        grid.style.minHeight = '';
        return;
    }

    // Fetch real product cards from the collection
    const cardsByHandle = await fetchCatalogCards();
    if (!cardsByHandle) {
        grid.innerHTML = `
        <li class="neve-results-empty">
            <p class="neve-results-empty__msg">Loading results…</p>
        </li>`;
        grid.style.visibility = '';
        grid.style.minHeight = '';
        return;
    }

    // Render cards in search-ranked order
    grid.innerHTML = '';
    handles.forEach(handle => {
        const cardHTML = cardsByHandle[handle];
        if (!cardHTML) return;

        const wrapper = document.createElement('div');
        wrapper.innerHTML = cardHTML;
        const card = wrapper.firstElementChild;
        if (!card) return;

        // Wrap in li.grid__item so Shopify's grid CSS applies
        let li;
        if (card.tagName === 'LI') {
        li = card;
        } else {
        li = document.createElement('li');
        li.className = 'grid__item';
        li.appendChild(card);
        }

        grid.appendChild(li);

        // Append match reasons below price
        const productReasons = reasons[handle] || [];
        if (productReasons.length > 0) {
        appendReasonsToCard(card, productReasons);
        }
    });

    // Store state for any future filter/sort use
    window.__NEVE_SEARCH__ = {
        query,
        results,
        handles,
        reasons,
        cardsByHandle
    };

    // Reveal grid and re-init carousels on injected cards
    grid.style.visibility = '';
    grid.style.minHeight = '';
    reinitCarousels();
    }

  // Fetch /collections/frontpage and extract product cards by handle
  async function fetchCatalogCards() {
    try {
      const resp = await fetch('/collections/frontpage?view=ajax', { credentials: 'same-origin' });
      let html = '';
      if (resp.ok) html = await resp.text();
      // Fallback if ajax view doesn't exist
      if (!html || html.length < 100) {
        const resp2 = await fetch('/collections/frontpage', { credentials: 'same-origin' });
        html = await resp2.text();
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const grid = doc.getElementById('product-grid');
      if (!grid) return null;

      const cardsByHandle = {};
      Array.from(grid.children).forEach(card => {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        const m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        cardsByHandle[m[1]] = card.outerHTML;
      });
      return cardsByHandle;
    } catch (err) {
      console.error('NEVE: failed to fetch catalog', err);
      return null;
    }
  }

  function appendReasonsToCard(card, productReasons) {
    if (card.querySelector('.neve-match-reasons')) return;

    const reasonsEl = document.createElement('div');
    reasonsEl.className = 'neve-match-reasons';
    reasonsEl.innerHTML = productReasons.map(r => `<span>${esc(r)}</span>`).join('');

    const priceEl = card.querySelector('.price, .card__price');
    if (priceEl && priceEl.parentNode) {
      if (priceEl.nextSibling) {
        priceEl.parentNode.insertBefore(reasonsEl, priceEl.nextSibling);
      } else {
        priceEl.parentNode.appendChild(reasonsEl);
      }
    } else {
      const cardInfo = card.querySelector('.card__information, .card-information, .card__content');
      if (cardInfo) cardInfo.appendChild(reasonsEl);
      else card.appendChild(reasonsEl);
    }
  }

  function updateResultsHeader(query, count) {
    const heading = document.querySelector('.template-search__header h1, h1.title, .title--primary');
    if (heading) {
        heading.textContent = `Results for "${query}"`;
    }
    const headerArea = document.querySelector('.template-search__header');
    if (headerArea && !headerArea.querySelector('.neve-results-header')) {
        const meta = document.createElement('span');
        meta.className = 'neve-results-header';
        meta.innerHTML = count > 0
        ? `${count} match${count !== 1 ? 'es' : ''}`
        : 'No matches';
        headerArea.appendChild(meta);
    }
  }



  // ─── Boot ─────────────────────────────────────────────────────────────────
  function boot() {
    if (!window.__NEVE_PRODUCTS__) {
      document.addEventListener('DOMContentLoaded', boot);
      return;
    }
    injectStyles();
    patchCustomElements(window.__NEVE_PRODUCTS__);
    directFallback(window.__NEVE_PRODUCTS__);
    fixIOSZoom();

    if (window.location.pathname === '/search') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleResultsPage);
      } else {
        handleResultsPage();
      }
    }
  }

  boot();

})();
